import { render, staticRenderFns } from "./EkycDashboard.vue?vue&type=template&id=7f02ede2&"
import script from "./EkycDashboard.vue?vue&type=script&lang=js&"
export * from "./EkycDashboard.vue?vue&type=script&lang=js&"
import style0 from "./EkycDashboard.vue?vue&type=style&index=0&id=7f02ede2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports